import * as React from 'react';
import { CompanyResourceEditActionsToolbar } from '../../company/components/company-resource-edit-actions-toolbar';
import { DepartmentRecord } from '../interfaces/department-record.interface';

export const DepartmentEditActions = (props: { record: DepartmentRecord }) => {
  const { record } = props;

  if (record) {
    return <CompanyResourceEditActionsToolbar record={record} />;
  } else {
    return <div />;
  }
};
